// extracted by mini-css-extract-plugin
export default {"footerBar":"footer_footerBar__ASqSL","footerContent":"footer_footerContent__34eaZ"};